export default "__VITE_ASSET__HcoPKawg__"